import { render, staticRenderFns } from "./CienciaEmCasa.vue?vue&type=template&id=0788ed4c&scoped=true&"
import script from "./CienciaEmCasa.vue?vue&type=script&lang=ts&"
export * from "./CienciaEmCasa.vue?vue&type=script&lang=ts&"
import style0 from "./CienciaEmCasa.vue?vue&type=style&index=0&id=0788ed4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788ed4c",
  null
  
)

export default component.exports